import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ComplianceListView } from '../features/compliance/components/ComplianceListView';
import {
  clearLastComplianceRoute,
  getLastComplianceRoute,
} from '../features/compliance/lib/navigation';

export const CompliancePage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const shouldSkipResume =
      (location.state as { skipComplianceResume?: boolean } | null)
        ?.skipComplianceResume === true;
    if (shouldSkipResume) {
      clearLastComplianceRoute();
      return;
    }
    const lastRoute = getLastComplianceRoute();
    if (lastRoute && lastRoute !== location.pathname) {
      navigate(lastRoute, { replace: true });
    }
  }, [location.pathname, location.state, navigate]);

  return <ComplianceListView />;
};

CompliancePage.displayName = 'CompliancePage';

CompliancePage.displayName = 'CompliancePage';
